export default __webpack_public_path__ + "static/media/SDG-icon-NL-12.b6758487.svg";